import { IInvoiceRepository } from "domain/contracts/invoice.contracts";
import { Invoice } from "domain/entities/invoice";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class InvoiceRepository implements IInvoiceRepository {

  async update(input: Invoice): Promise<Message<boolean>> {
    const response = await httpClient.put(`/invoice/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getById(id: string): Promise<Message<Invoice>> {
    const response = await httpClient.get(`/invoice/${id}`);
    return response.data;
  }
}

export default new InvoiceRepository();
